import React from 'react';
import Container from '@amzn/awsui-components-react/polaris/container';
import Header from '@amzn/awsui-components-react/polaris/header';
import Box from '@amzn/awsui-components-react/polaris/box';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import Spinner from '@amzn/awsui-components-react/polaris/spinner';
import { useAnalyticsData } from '../../../hooks';

const UserAnalytics: React.FC = () => {
  const { data, loading, error } = useAnalyticsData();

  if (loading) {
    return (
      <Container>
        <Box textAlign="center" padding="l">
          <Spinner />
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Box color="text-status-error" textAlign="center" padding="l">
          Error loading user data
        </Box>
      </Container>
    );
  }

  const userMetrics = data && data.userMetrics;

  return (
    <Container
      header={
        <Header variant="h2">
          User Analytics
        </Header>
      }
    >
      <SpaceBetween direction="vertical" size="m">
        <Box>
          <Box variant="awsui-key-label">User Retention Rate</Box>
          <Box fontSize="heading-xl" fontWeight="bold" color="text-status-success">
            {(userMetrics && userMetrics.retentionRate) || 0}%
          </Box>
        </Box>

        <SpaceBetween direction="vertical" size="xs">
          <Box>
            <Box variant="small">Total Users</Box>
            <Box fontWeight="bold">{(userMetrics && userMetrics.totalUsers) || 0}</Box>
          </Box>
          
          <Box>
            <Box variant="small">Active Users (30d)</Box>
            <Box fontWeight="bold">{(userMetrics && userMetrics.activeUsers30d) || 0}</Box>
          </Box>
          
          <Box>
            <Box variant="small">New Users Today</Box>
            <Box fontWeight="bold">{(userMetrics && userMetrics.newUsersToday) || 0}</Box>
          </Box>
        </SpaceBetween>

        <Box variant="small" color="text-status-info">
          Last updated: {(userMetrics && userMetrics.lastUpdated) ? new Date(userMetrics.lastUpdated).toLocaleString() : 'N/A'}
        </Box>
      </SpaceBetween>
    </Container>
  );
};

export default UserAnalytics;
